var exports = {
  "S": "xfd349460--472963--image",
  "w": "xfd349460--472963--image-icon",
};

module.exports = exports;
